
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/stories/[storyId]",
      function () {
        return require("private-next-pages/stories/[storyId].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/stories/[storyId]"])
      });
    }
  